import { render, staticRenderFns } from "./intel_agriculture.vue?vue&type=template&id=54a75cf4&scoped=true&"
import script from "./intel_agriculture.vue?vue&type=script&lang=js&"
export * from "./intel_agriculture.vue?vue&type=script&lang=js&"
import style0 from "./intel_agriculture.vue?vue&type=style&index=0&id=54a75cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a75cf4",
  null
  
)

export default component.exports